// extracted by mini-css-extract-plugin
module.exports = {"root":"MvKnB","isBlackDot":"W5iWm","isImportant":"_1pJCc","lasted":"_1RjZ3","middle":"_37bZd","old":"_1E9k0"};